import { attachmentService } from '@/services/attachment';
import { IPlanAttachment } from '@/types/plan';

export const processHtmlWithAttachments = async (
  htmlContent: string,
  planAttachments: IPlanAttachment[]
): Promise<string> => {
  if (!htmlContent || !planAttachments.length) {
    return htmlContent;
  }

  const imageAttachments = planAttachments.filter(
    (pa) =>
      !pa.isArchived &&
      pa.attachment.mimeType.startsWith('image/') &&
      !pa.attachment.fileName.endsWith('.zip')
  );

  let processedHtml = htmlContent;

  for (const attachment of imageAttachments) {
    const fileName = attachment.attachment.fileName;
    const imageName = attachment.attachment.originName.split('/').pop();

    if (!imageName) continue;

    try {
      const apiUrl = attachmentService.getAttachmentDirectUrl(fileName);

      if (apiUrl) {
        const relativeSrcPattern = new RegExp(
          `src=["']([^"']*${escapeRegExp(imageName)})["']`,
          'gi'
        );
        processedHtml = processedHtml.replace(relativeSrcPattern, (match, url) => {
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            return match.replace(url, apiUrl);
          }
          return match;
        });

        const relativeHrefPattern = new RegExp(
          `href=["']([^"']*${escapeRegExp(imageName)})["']`,
          'gi'
        );
        processedHtml = processedHtml.replace(relativeHrefPattern, (match, url) => {
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            return match.replace(url, apiUrl);
          }
          return match;
        });
        const relativeUrlPattern = new RegExp(
          `url\\(["']?([^"']*${escapeRegExp(imageName)})["']?\\)`,
          'gi'
        );
        processedHtml = processedHtml.replace(relativeUrlPattern, (match, url) => {
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            return match.replace(url, apiUrl);
          }
          return match;
        });
      }
    } catch (error) {
      console.warn(`Failed to process attachment ${fileName}:`, error);
    }
  }

  return processedHtml;
};

function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const processCssWithAttachments = async (
  cssContent: string,
  planAttachments: IPlanAttachment[]
): Promise<string> => {
  if (!cssContent || !planAttachments.length) {
    return cssContent;
  }

  const imageAttachments = planAttachments.filter(
    (pa) =>
      !pa.isArchived &&
      pa.attachment.mimeType.startsWith('image/') &&
      !pa.attachment.fileName.endsWith('.zip')
  );

  let processedCss = cssContent;

  for (const attachment of imageAttachments) {
    const fileName = attachment.attachment.fileName;
    const imageName = fileName.split('/').pop();

    if (!imageName) continue;

    try {
      const apiUrl = attachmentService.getAttachmentDirectUrl(fileName);

      if (apiUrl) {
        const relativeUrlPattern = new RegExp(
          `url\\(["']?([^"']*${escapeRegExp(imageName)})["']?\\)`,
          'gi'
        );
        processedCss = processedCss.replace(relativeUrlPattern, (match, url) => {
          if (!url.startsWith('http://') && !url.startsWith('https://')) {
            return match.replace(url, apiUrl);
          }
          return match;
        });
      }
    } catch (error) {
      console.warn(`Failed to process CSS attachment ${fileName}:`, error);
    }
  }

  return processedCss;
};
